var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 29.6485C32.449 28.9214 33.705 28.9214 34.4886 29.6485L39.6672 33.554H39.7571C40.8049 34.5434 40.8049 36.1476 39.7571 37.137C38.7094 38.1264 37.0108 38.1264 35.963 37.137L31.6655 32.5352L31.5024 32.3633C31.1986 32.004 31.0308 31.5561 31.0308 31.0918C31.0308 30.5502 31.2592 30.0308 31.6655 29.6485ZM17.3881 0C21.9998 0 26.4225 1.73 29.6834 4.80943C32.9443 7.88886 34.7763 12.0655 34.7763 16.4204C34.7763 25.4892 26.9913 32.8408 17.3881 32.8408C7.78493 32.8408 0 25.4892 0 16.4204C0 7.35167 7.78493 0 17.3881 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.37c8a5fc495ea3986ae08f94a4843ac5.svg";
export { ForwardRef as ReactComponent };